import { IBrand, IChannel, IChannelType, IShopifyConnectionData } from "../services/brand/types";

// #region shopifyAdminProductUrl
/**
 * Builds the Shopify **admin** product link from the brand's `*.myshopify.com`
 * domain. Returns null when the domain is unavailable — the caller must omit
 * the link rather than fall back to `storefront_domain`, which is the public
 * storefront and would 404 under /admin.
 */
export const shopifyAdminProductUrl = (brand: IBrand | null | undefined, productId?: string | null): string | null => {
    if (!brand || !productId) return null;

    // Backend may return a GID or a bare numeric id; normalise to numeric.
    const numericId = String(productId).replace(/^gid:\/\/shopify\/Product\//, '').trim();
    if (!numericId) return null;

    const shopifyChannel = brand.channels?.find((channel: IChannel) => channel.channel_type === IChannelType.SHOPIFY);
    const connectionData = shopifyChannel?.connection_data as IShopifyConnectionData | undefined;

    const rawName = connectionData?.shopify_brand_name || brand.shopify_brand_name;
    if (!rawName) return null;

    const storeHandle = String(rawName).replace(/^https?:\/\//, '').replace(/\.myshopify\.com.*$/i, '').replace(/\/$/, '');
    if (!storeHandle) return null;

    return `https://admin.shopify.com/store/${storeHandle}/products/${numericId}`;
};
